/* KODO hero animation — ported from kodo-landing/app.js (WordsPullUp +
   staggered fade-up). Scoped per section instance; re-runs after Shopify
   theme-editor section reloads. Progressive enhancement: no JS → all visible. */
(function () {
  var STAGGER = 0.08; // matches delay: i * 0.08 in WordsPullUp

  function splitWords(el) {
    if (!el || el.dataset.split === 'true') return;
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.textContent = '';
    var i = 0;
    nodes.forEach(function (node) {
      if (node.nodeType === 3) { // text node
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (part === '') return;
          if (/^\s+$/.test(part)) { el.appendChild(document.createTextNode(' ')); return; }
          var span = document.createElement('span');
          span.className = 'kodo-word';
          span.textContent = part;
          span.style.setProperty('--d', (i * STAGGER).toFixed(2) + 's');
          el.appendChild(span);
          i += 1;
        });
      } else {
        el.appendChild(node.cloneNode(true)); // keep <br>
      }
    });
    el.dataset.split = 'true';
  }

  function initHero(root) {
    if (root.dataset.kodoHeroInit === 'true') return;
    root.dataset.kodoHeroInit = 'true';

    var heading = root.querySelector('[data-hero-heading]');
    splitWords(heading);

    // Stagger the fade-up elements after the heading words (eyebrow → body → buttons).
    var fades = [
      [root.querySelector('[data-hero-eyebrow]'), 0],
      [root.querySelector('[data-hero-body]'), 0.5],
      [root.querySelector('[data-hero-actions]'), 0.7]
    ];
    fades.forEach(function (pair) {
      if (pair[0]) pair[0].style.setProperty('--d', pair[1] + 's');
    });

    // Hero is above the fold; reveal on load. setTimeout isn't throttled the
    // way rAF/IntersectionObserver are when the tab isn't actively painting.
    setTimeout(function () { root.classList.add('is-revealed'); }, 0);
  }

  function init() {
    document.querySelectorAll('[data-kodo-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-kodo-hero]');
    if (root) { root.dataset.kodoHeroInit = ''; initHero(root); }
  });
})();
